export default "__VITE_ASSET__DT8inHda__"